import {
  JOIN_SOCKET_CHANNEL,
  JOIN_SOCKET_CHANNEL_FAILED,
  LEAVE_SOCKET_CHANNEL,
  SET_SOCKETS_CONNECTED,
  SET_SOCKETS_DISCONNECTED
} from 'constants';

export const socket = (state = {
  channels : [
    'live-map-editing',
    'live-weather-center',
    'all',
    'admin'
  ],
  connected : false,
}, action) => {
  const { payload, type } = action;
  switch(type) {
    case JOIN_SOCKET_CHANNEL:
      return {
        ...state,
        channels : [
        ...state.channels.filter(channel => channel != payload.channel),
        payload.channel
        ]
      }
    case LEAVE_SOCKET_CHANNEL:
      return {
        ...state,
        channels : [
          ...state.channels.filter(channel => channel == payload.channel)
        ],
      }
    case SET_SOCKETS_CONNECTED:
      return {...state, connected: true}
    case SET_SOCKETS_DISCONNECTED:
      return {...state, connected: false}
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/socket.js